export enum OdometerDriftTolerance {
    min = 5,
    max = 500,
}

export enum HourMeterDriftTolerance {
    min = 0.25,
    max = 25,
}
